type OrderSequenceItem = {
    day: string | number;
    installs_total: string | number;
    installs_actual: number;
};

type Order = {
    type: number;
    sequence: OrderSequenceItem[];
    installs_actual?: number;
    installs_total?: number;
};

type OrdersMapValue = {
    installs_total: number;
    installs_actual: number;
};

export class ImpressionsUtil {
  public static handleImpressionsOrder = (data) => {
    const impressionsOrderType = 8;
    const orders: Order[] = data.data.orders;
    const ordersMap: Record<number, OrdersMapValue> = {};

    orders
      .filter(order => order.type === impressionsOrderType)
      .forEach((order) => {
        order.sequence.forEach(({ day, installs_total, installs_actual }) => {
          const dayNum = Number(day);
          const installsTotalNum = Number(installs_total);
          const installsActualNum = Number(installs_actual);

          if (!ordersMap[dayNum]) {
            ordersMap[dayNum] = { installs_total: installsTotalNum, installs_actual: installsActualNum };
          } else {
            ordersMap[dayNum].installs_total += installsTotalNum;
            ordersMap[dayNum].installs_actual += installsActualNum;
          }
        });
      });

    const ordersSequence = Object.entries(ordersMap)
      .map(([day, obj]) => ({
        day: Number(day),
        installs_total: obj.installs_total,
        installs_actual: obj.installs_actual,
      }))
      .sort((a, b) => a.day - b.day);

    const targetIndex = orders.findIndex(order => order.type === impressionsOrderType);

    if (targetIndex !== -1) {
      const targetOrder = orders[targetIndex];
      targetOrder.sequence = ordersSequence;
      targetOrder.installs_total = ordersSequence.reduce(
        (sum, { installs_total }) => sum + Number(installs_total),
        0
      );
      targetOrder.installs_actual = ordersSequence.reduce(
        (sum, { installs_actual }) => sum + Number(installs_actual),
        0
      );
    }

    data.data.orders = orders.filter((order, index) => {
      if (order.type !== impressionsOrderType) return true;
      return index === targetIndex;
    });
  };
}
